module.exports = __webpack_public_path__ + "img/Daniel.39ccb5b1.jpg";